import React, { memo } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import FullscreenIcon from '@material-ui/icons/Fullscreen'

export type FullScreenProps = {
    element: HTMLElement | null
}

export const FullScreen = memo(({ element }: FullScreenProps) => {
    const toggleFullScreen = (event: any) => {
        event.preventDefault()
        event.stopPropagation()

        if (document.fullscreenElement) {
            document.exitFullscreen()
        } else {
            if (element) element.requestFullscreen()
        }
    }

    return (
        <Tooltip
            title={`${
                document.fullscreenElement ? 'Exit' : 'Enter'
            } Full Screen`}
        >
            <FullscreenIcon
                style={{ color: 'white', cursor: 'pointer' }}
                onClick={toggleFullScreen}
            />
        </Tooltip>
    )
})
